<template>
	<div id="app">
		<div class="reader-box" v-show="videoEditStore.getShowRender" id="render-wrap-yoya">
			<RanderCanvas class="preview" v-if="initRender"></RanderCanvas>
		</div>
		<router-view />
		<!-- 更新提示组件 -->
		<UpdateTips />
		<TutorialGuide
			v-if="showGlobalGuide && hasGuideForCurrentRoute"
			:guide-data="guideData"
			@skip="handleSkip"
			@action="handleAction"
			:key="route.path"
		/>
	</div>
</template>
<script setup lang="ts">
import('../src/theme/theme')
import { getUserInfo, getPoints as APIGetPoints, getUserGuide as ApiGetUserGuide } from '@/api'
import { useUserStore } from './store/user'
import { useRoute, useRouter } from 'vue-router'
import { isPublicRoute } from '@/baseUtils/router'
import { onMounted, ref, inject, watch, computed } from 'vue'
import RanderCanvas from '@/rander/index.vue'
import { useVideoEditorStore } from '@/store/videoEditorStore'
import UpdateTips from '@/components/newTips/UpdateTips.vue'
import { initUpdateTips } from '@/utils/updateTipsManager'
import { getBeginnerGuidanceShowList } from '@/api/guide'

const videoEditStore = useVideoEditorStore()
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()
const initRender = ref(false)

// 添加一个标记防止重复初始化
const hasInit = ref(false)
const { guideData, showGlobalGuide, markAsCompleted } = inject('guide')

// 计算当前路由是否有引导
const hasGuideForCurrentRoute = computed(() => {
	return guideData.value[route.path]?.steps?.length > 0
})
const transformGuideData = apiData => {
	const result = {}

	apiData.forEach(item => {
		if (!item.route || !item.stepsJson) return

		try {
			const steps = JSON.parse(item.stepsJson).steps
			const routeKey = `/${item.route}`

			result[routeKey] = { steps, id: item.id, name: item.name }
		} catch (e) {
			console.error(`Failed to parse guide data for ${item.route}:`, e)
		}
	})

	return result
}
// 加载引导数据
const loadGuideData = async () => {
	try {
		const response = await getBeginnerGuidanceShowList()
		const data = transformGuideData(response.data)

		guideData.value = data
		// console.log(data, '=========重构数据')

		// 自动显示当前路由的引导（如果存在且未完成）
		if (hasGuideForCurrentRoute.value) {
			console.log('hasGuideForCurrentRoute.value', hasGuideForCurrentRoute.value)
			showGlobalGuide.value = true
		}
	} catch (error) {
		console.error('加载引导数据失败:', error)
		// 如果是认证错误，可能是用户未登录，暂时不处理
		if (error.response?.status !== 401) {
			throw error
		}
	}
	// 预加载所有步骤图片

	// guideData.value = {
	// 	'/videoEdit': {
	// 		// steps:`json串`
	// 		steps: [
	// 			{
	// 				content: `<div>
	// 				<p class="title" >创作文案</p>
	// 				<p class="content" >在左侧输入框内，输入视频的创作要求，点击<img src="${
	// 					new URL('@/assets/img/sent.png', import.meta.url).href
	// 				}" class='guide-image' style='width: 20px;'/>,大模型将根据您的需求进行视频旁白文案创作。

	//  </p>
	// 			</div>`,
	// 				x: 436,
	// 				y: 840,
	// 				backgroundImage: new URL('@/assets/img/guide/js1.png', import.meta.url).href, //1920*1080
	// 				buttons: {
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'left',
	// 				// 可以覆盖全局配置
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 100, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: -20,
	// 						y: 50
	// 					}
	// 				},
	// 				stepNum: true
	// 			},
	// 			{
	// 				content: `<div>
	// 				<p class="title" >文案优化</p>
	// 				<p class="content" >编辑并确定文案后点击【采用文案】按钮，将开始匹配视频素材，进行自动剪辑。

	//  </p>
	// 			</div>`,
	// 				x: 10,
	// 				y: 460,
	// 				backgroundImage: new URL('@/assets/img/guide/js2.png', import.meta.url).href,
	// 				buttons: {
	// 					prev: true,
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'top',
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 60, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: 46,
	// 						y: -20
	// 					}
	// 				},
	// 				stepNum: true
	// 			},
	// 			{
	// 				content: `<div>
	// 				<p class="title" >素材编辑</p>
	// 				<p class="content" >YOYA将根据您采用的文案，精准匹配合适的视频片段并自动上轨。<br/>您可以对片段进行替换素材、市场调节、交换位置、重选时段、删除等操作。

	//  </p>
	// 			</div>`,
	// 				x: 860,
	// 				y: 580,
	// 				backgroundImage: new URL('@/assets/img/guide/js3.png', import.meta.url).href,
	// 				buttons: {
	// 					prev: true,
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'bottom',
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 90, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: 180,
	// 						y: 200
	// 					}
	// 				},
	// 				stepNum: true
	// 			},
	// 			{
	// 				content: `<div>
	// 				<p class="title" >音频&数字人编辑</p>
	// 				<p class="content" >您可以对视频的朗读声、背景音进行手动替换或音量调整。<br/>
	//         还可以在画面中插入数字人形象，让TA帮你完成内容讲解、歌曲跟唱等场景。
	//  </p>
	// 			</div>`,
	// 				x: 1200,
	// 				y: 520,
	// 				backgroundImage: new URL('@/assets/img/guide/js4.png', import.meta.url).href,
	// 				buttons: {
	// 					prev: true,
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'bottom',
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 90, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: 150,
	// 						y: 200
	// 					}
	// 				},
	// 				stepNum: true
	// 			},
	// 			{
	// 				content: `<div>
	// 				<p class="title" >高清合成视频</p>
	// 				<p class="content" >在视频编辑的过程中，为保障浏览器的流畅使用，我们采用360P的清晰度进行素材预览，同时推荐素材也保留有版权水印。在确定视频内容后，您可以点击【高清合成】获得1080P的高清成片。

	//  </p>
	// 			</div>`,
	// 				x: 1460,
	// 				y: 130,
	// 				backgroundImage: new URL('@/assets/img/guide/js5.png', import.meta.url).href,
	// 				buttons: {
	// 					prev: true,
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'top',
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 60, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: 300,
	// 						y: -17
	// 					}
	// 				},
	// 				stepNum: false,
	// 				isFinal: true
	// 			}
	// 		]
	// 	},
	// 	'/VoiceClone': {
	// 		// steps:`json串`
	// 		steps: [
	// 			{
	// 				content: `<div>
	// 				<p class="title" >文案配音</p>
	// 				<p class="content" >您可以粘贴或输入需要配音的文案，选择想使用的音色，调整朗读语速和音量，即可开始配音生成音频。

	//  </p>
	// 			</div>`,
	// 				x: 406,
	// 				y: 200,
	// 				backgroundImage: new URL('@/assets/img/clone/cl1.png', import.meta.url).href, //1920*1080
	// 				buttons: {
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'left',
	// 				// 可以覆盖全局配置
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 100, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: -20,
	// 						y: 50
	// 					}
	// 				},
	// 				stepNum: true
	// 			},
	// 			{
	// 				content: `<div>
	// 				<p class="title" >音乐翻唱</p>
	// 				<p class="content" >点击【去唱歌】，可以上传一首歌曲，选择想使用的音色，即可对歌曲进行翻唱生成音频。支持您下载或去生成MV。

	//  </p>
	// 			</div>`,
	// 				x: 406,
	// 				y: 200,
	// 				backgroundImage: new URL('@/assets/img/clone/cl2.png', import.meta.url).href,
	// 				buttons: {
	// 					prev: true,
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'left',
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 100, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: -20,
	// 						y: 50
	// 					}
	// 				},
	// 				stepNum: true
	// 			},
	// 			{
	// 				content: `<div>
	// 				<p class="title" >声音训练</p>
	// 				<p class="content" >可以进行在线录制通过朗读展示的文案来录制您的声音，或直接上传需要训练的声音音频，支持MP3/MAV格式，时长5-30s,大小不超过100M。训练完成的声音可以用于文案配音或音乐翻唱。

	//  </p>
	// 			</div>`,
	// 				x: 466,
	// 				y: 180,
	// 				backgroundImage: new URL('@/assets/img/clone/cl3.png', import.meta.url).href,
	// 				buttons: {
	// 					prev: true,
	// 					next: true,
	// 					skip: true
	// 				},
	// 				guideLineDirection: 'left',
	// 				guideLineOptions: {
	// 					color: '#FBD38D', // 引导线颜色
	// 					width: '1px', // 引导线宽度
	// 					length: 100, // 引导线长度
	// 					dotSize: '8px', // 圆点大小
	// 					dotBorder: '2px', // 边框粗细

	// 					dotBorderColor: 'rgba(0,0,0,0.3)', // 半透明白色边框
	// 					dotBackground: '#1890ff', // 圆点中心颜色
	// 					offset: {
	// 						x: -20,
	// 						y: 50
	// 					}
	// 				},
	// 				stepNum: true
	// 			}
	// 		]
	// 	}
	// }
}

// 处理跳过
const handleSkip = () => {
	markAsCompleted(route.path)
	showGlobalGuide.value = false
	// 可以添加分析事件等
	// 点击跳过重新获取guideData
	loadGuideData()
}

// 处理完成动作
const handleAction = () => {
	markAsCompleted(route.path)
	showGlobalGuide.value = false
	loadGuideData()

	// 根据当前路由执行不同操作
	switch (route.path) {
		case '/videoEdit':
			// 开始创作逻辑

			break
		case '/aiMusic':
			// 进入编辑逻辑
			break

			break
		// 其他路由处理...
	}
}

const checkAndLoadGuideData = async () => {
	// 只有在用户已登录且引导数据为空时才加载
	if (userStore.loginState && (!guideData.value || Object.keys(guideData.value).length === 0)) {
		try {
			await loadGuideData()
		} catch (error) {
			console.error('加载引导数据失败:', error)
		}
	}

	// 检查当前路由是否需要引导
	if (guideData.value[route.path]?.steps?.length > 0) {
		showGlobalGuide.value = true
	}
}
// 初始化时加载数据
onMounted(() => {
	loadGuideData()
})

localStorage.setItem('locale', 'zh-CN')

// 初始化用户信息
const initUserInfo = async () => {
	if (hasInit.value) return
	hasInit.value = true

	try {
		// 获取用户信息
		const res: any = await getUserInfo()
		if (res.success) {
			const resData = res.data[0]
			localStorage.setItem('loginState', '1')
			localStorage.setItem('nickName', resData.nickName)
			localStorage.setItem('userId', resData.userId)
			userStore.nickName = resData.nickName
			userStore.email = resData.email
			userStore.userName = resData.userName
			userStore.mobile = resData.mobile
			userStore.createTime = resData.createTime
			userStore.workWechatId = resData.workWechatId || null
			userStore.loginState = true
			// 获取积分
			getPoints()
			// 获取指引信息
			getUserGuide()
			// 获取容量
			userStore.getCapacity()

			// 初始化更新提示系统（用户已登录状态下刷新页面）
			try {
				await initUpdateTips(router)
			} catch (error) {
				console.warn('Failed to initialize update tips:', error)
			}
		}
	} catch (error) {
		console.error('Failed to fetch user info:', error)
		// 初始化失败，清理用户状态
		userStore.clearUserInfo()

		// 只有在非公开路由时才重定向
		if (!isPublicRoute(route.path) && route.path !== '/') {
			router.push('/')
		}
	}
}

// 获取积分
const getPoints = async () => {
	try {
		const res = await APIGetPoints()
		userStore.points = res.data[0] || 0
	} catch (err) {
		console.log(err)
	}
}

// 获取指引信息
const getUserGuide = async () => {
	try {
		const res = await ApiGetUserGuide()
		const list = res.data || []
		userStore.setGuide(list)
	} catch (err) {
		console.log(err)
	}
}

// 在挂载时始终执行初始化
onMounted(() => {
	initUserInfo()
	// 一秒后加载渲染区
	setTimeout(() => {
		initRender.value = true
	}, 1000)
})
// 监听用户登录状态
watch(
	() => userStore.loginState,
	async isLoggedIn => {
		if (isLoggedIn) {
			// 用户登录后立即检查并加载引导数据
			await checkAndLoadGuideData()
		}
	}
)
// 监听路由变化
watch(
	() => route.path,
	async newPath => {
		// 路由变化时检查并加载引导数据
		await checkAndLoadGuideData()

		// 延迟检查当前路由是否需要引导
		setTimeout(() => {
			if (guideData.value[newPath]?.steps?.length > 0) {
				showGlobalGuide.value = true
			} else {
				showGlobalGuide.value = false
			}
		}, 100)
	}
)
</script>

<style scoped lang="less">
.reader-box {
	position: absolute;
	width: 0;
	height: 0;
	z-index: 101;
}
// 使用 Less 变量定义屏幕宽度和高度
@screen-width: 100vw;
@screen-height: 100vh;
#app {
	width: @screen-width;
	height: @screen-height;
	// width: 2180px;
	// height: 1080px;
	overflow: hidden;
}

body {
	margin: 0;
	padding: 0;
}
</style>

<style lang="less">
#nprogress .bar {
	background: var(--primary-color); //自定义颜色
}
</style>
